import { OfferKindEnum } from '../../../../services/exports/Constants';

const offers: Record<OfferKindEnum & { from_to: string }, any> = {
  [OfferKindEnum.PercentageOffByProducts]: {
    title: 'Oszczędź {{percentageAmount}}% na wybranych produktach',
    description:
      'Oszczędź {{percentageAmount}}% na zamówieniu, gdy zamówisz wybrane produkty. Oferta jest ważna{{fromTo}} do osiągnięcia maksymalnego limitu promocji, w zależności od tego, co nastąpi pierwsze. Nie łączy się z innymi promocjami.',
  },
  [OfferKindEnum.PercentageOffByMinSpendValue]: {
    title: '{{percentageAmount}}% zniżki od {{minSpendValue}}',
    description:
      'Oszczędź {{percentageAmount}}% na swoim zamówieniu. Oferta jest ważna{{fromTo}} do osiągnięcia maksymalnego limitu promocji, w zależności od tego, co nastąpi pierwsze. Nie łączy się z innymi promocjami.',
  },
  [OfferKindEnum.AmountOffByProducts]: {
    title: 'Oszczędź {{amount}} na wybranych produktach',
    description:
      'Oszczędź {{amount}}, zamawiając wybrane produkty. Oferta jest ważna{{fromTo}} do osiągnięcia maksymalnego limitu promocji, w zależności od tego, co nastąpi pierwsze. Nie łączy się z innymi promocjami.',
  },
  [OfferKindEnum.AmountOffByMinSpendValue]: {
    title: 'Oszczędź {{amount}} od {{minSpendValue}}',
    description:
      'Oszczędź {{amount}} przy określonej wartości zamówienia. Oferta jest ważna{{fromTo}} do osiągnięcia maksymalnego limitu promocji, w zależności od tego, co nastąpi pierwsze. Nie łączy się z innymi promocjami.',
  },
  [OfferKindEnum.Bogo]: {
    title: '2 w cenie 1!',
    description:
      'Kup jeden produkt i otrzymaj drugi gratis. Oferta jest ważna{{fromTo}} do wyczerpania limitu promocji, w zależności od tego, co nastąpi pierwsze. Nie łączy się z innymi promocjami.',
  },
  [OfferKindEnum.BogoHalfPrice]: {
    title: 'Kup jeden, drugi w połowie ceny!',
    description:
      'Kup jeden produkt i otrzymaj drugi w połowie ceny. Oferta jest ważna{{fromTo}} do wyczerpania limitu promocji, w zależności od tego, co nastąpi pierwsze. Nie łączy się z innymi promocjami.',
  },
  [OfferKindEnum.FreeItemByMinSpendValue]: {
    title: 'Darmowy produkt przy określonej wartości zamówienia',
    description:
      'Otrzymaj darmowy produkt po spełnieniu warunków oferty. Oferta jest ważna{{fromTo}} do wyczerpania limitu promocji, w zależności od tego, co nastąpi pierwsze. Nie łączy się z innymi promocjami.',
    reward_items_description: 'Wybierz swój darmowy produkt.',
  },
  [OfferKindEnum.FreeItemByProducts]: {
    title: 'Darmowy produkt do zamówienia',
    description:
      'Otrzymaj darmowy produkt po spełnieniu warunków oferty. Oferta jest ważna{{fromTo}} do wyczerpania limitu promocji, w zależności od tego, co nastąpi pierwsze. Nie łączy się z innymi promocjami.',
    qualifying_items_description: 'Wybierz produkty, które klient musi zamówić, aby otrzymać darmowy produkt.',
    reward_items_description: 'Wybierz swój darmowy produkt.',
  },
};

export default {
  offers,
  from_to: ' od {{startsAt}} do {{endsAt}} lub',
  qualifying_items_title: 'Produkty uprawniające',
  reward_items_title: 'Darmowe produkty',
  buttons: {
    add: 'Dodaj do koszyka',
  },
};
